export const routerSelector = (state) => state.navigator
export const pathnameSelector = (state) => state?.navigator?.location?.pathname ?? null
